import SectionHeader from "../Common/SectionHeader";

const OrdersHeader = ({ title, subtitle }) => {
    return <SectionHeader title={title} subtitle={subtitle} className="md:items-start md:justify-between" />;
};

export default OrdersHeader;
